module.exports = __webpack_public_path__ + "static/2019-fineArt3-3142b2ef2e1e1ba84ba5ede71096847c.jpg";